
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import {
    materialGroupNotesmaterialGroupNotesPageList,
    materialGroupNotesmaterialGroupNotesDelete,
    materialGroupNotesmaterialGroupNotesEditShow
  } from "@/api/material"
	import Message from '@/components/message.vue'
	import Switch from '@/components/switch.vue'
	import Img from '@/components/img.vue'
	import{
		getSearchDate,
		nextDay
	}from "@/utils/index"
  @Component({  
    name: '',
    components: {
      PageFooter,
      Message,
      'rt-img':Img,
      'rt-switch':Switch
    }
  })

  export default class ProductList extends Vue {
    private pageNo = 1;
		private pageSize = 10;
		private total = 0;
    private timeValue:any = []
    private keyWords = ''
    private tablelist:any = []
    private tableloading = false

    private rowMsg:any = {}
    private delShow = false

    private mounted (){
      this.timeValue = [getSearchDate(2,false,-29)[0],getSearchDate(2)[0]]
      this.gettablelist()
    }
    activated () {
      this.gettablelist()
    }

    private async changeswitch(e,row){
      // console.log(e,row)
      try{
        this.tableloading = true
        let data = await row
        let res = await materialGroupNotesmaterialGroupNotesEditShow({
          Id:data.Id,
          IsShow:row.IsShow
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.gettablelist()
        }
      }finally{
        this.tableloading = false
      }
    }
    private async confirmDelete(row){
      try{
        let res = await materialGroupNotesmaterialGroupNotesDelete({
          Id:this.rowMsg.Id
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.delShow = false
          this.gettablelist()
        }
      }finally{
        //
      }
    }
    private delrow(row){
      this.rowMsg = row
      this.delShow = true
    }
    private editmaterial(row){
      this.$router.push({
        path:'groupnotesDetail',
        query:{
          Id:row.Id
        }
      })
    }
    private changeCurrent(e){
      this.pageNo = e
      this.gettablelist()
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private clearSearch(){
      this.keyWords = ''
      this.timeValue = [getSearchDate(2,false,-29)[0],getSearchDate(2)[0]]
      this.doSearch()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any = {
          Keywords:this.keyWords,
          StartTime:'',
          EndTime:'',
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        }
        if(this.timeValue&&this.timeValue.length){
          data.StartTime = this.timeValue[0]
          data.EndTime = nextDay(this.timeValue[1],1)
        }
        let res = await materialGroupNotesmaterialGroupNotesPageList(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results.map(v=>{
            v.StartGroupTime = v.StartGroupTime.substring(0,10)
            return v
          })
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
